import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import * as api from 'api';
import * as actionCreators from 'store/actions';

import { Button, Spinner, FormField, Modal } from 'components';
import { DeleteDialogue } from 'features';
import { FaCheck, FaTimes } from 'react-icons/fa';

const Container = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto auto;
    grid-gap: 0.5rem;
    margin-top: 0.2rem;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`

const SelectionContainer = styled.div`
    display: grid;
    grid-template-columns: 47.5% 47.5%;
    grid-column-gap: 5%;
`

const SelectionTile = styled.div`
    border-width: 2px;
    border-style: solid;
    border-color: ${props => props.selected ? 'var(--focus-color)' : 'var(--secondary-color)'};
    border-radius: 5px;
    padding: 0.5rem;
    font-size: 0.9rem;
    background-color: var(--secondary-color);
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Error = styled.div`
    font-size: 0.9rem;
    color: var(--error-color);
    margin-top: 0.2rem;
    :before {
        content: '*'
    }
`

const PaymentIntervalInput = props => {
    const { 
        onClose
    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const [value, setValue] = React.useState(user['subscription_frequency'])
    const [stage, setStage] = React.useState(null)
    const [error, setError] = React.useState(false)
    const [showDialogue, setDialogue] = React.useState(false)

    const getUrl = () => {
        if(user['subscription_frequency'] !== value){
            setStage('in-progress')
            api.updateSubscriptionPlan({userId: user['uid'], frequency: value})
            .then(res => {
                setTimeout(() => {
                    setStage('completed')
                    window.location.reload();
                }, 2000)
            })
            .catch(err => {
                setStage('failed')
                setTimeout(() => {
                    setDialogue(false)
                    setError('Changes not made, please try again')
                    setStage(null)
                }, 500)
            })
        } 
        
    }

    return (
        <Container>
            {/* Email input */}
            <SelectionContainer>
                <SelectionTile selected={value === 'MONTHLY'} onClick={() => setValue('MONTHLY')}>Monthly</SelectionTile>
                <SelectionTile selected={value === 'YEARLY'} onClick={() => setValue('YEARLY')}>Yearly</SelectionTile>
            </SelectionContainer>

            {/* Error */}
            {error && <Error>{error}</Error>}

            {/* Buttons */}
            <ButtonContainer>
                <Button text='Cancel' onSelect={onClose} styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}}/>
                <Button text='Save' onSelect={() => user['subscription_frequency'] !== value && setDialogue(true)} 
                    styles={{backgroundColor: 'var(--focus-color)', margin: 0, color: 'white'}} />
            </ButtonContainer>

            {/* Modal */}
            {showDialogue &&
            <Modal onClose={() => setDialogue(false)}>
                <DeleteDialogue closeHandler={() => setDialogue(false)} onDelete={getUrl}
                    submitText={stage === 'in-progress' ? <Spinner styles={{color: 'var(--text-color)'}}/> 
                                : stage === 'completed' ? <FaCheck/>
                                : stage === 'failed' ? <FaTimes/>
                                : 'Confirm' }
                    warningText='Change payment interval?' subtitle='Payment will be billed immediately if needed'
                    styles={{
                        boxShadow: 'var(--box-shadow)',
                        padding: '1rem',
                        border: '1px solid var(--primary-accent2-color)'
                    }}/>
            </Modal>}
        </Container>
    )
}

export default PaymentIntervalInput